import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { HelloSection } from "./components/HelloSection";
import { ServiceTags } from "./components/ServiceTags";
import { LogoMarquee } from "./components/LogoMarquee";
import { VideosSection } from "./components/VideosSection";
import { ProcessSection } from "./components/ProcessSection";
import { ContactSection } from "./components/ContactSection";

const Home = () => {
  return (
    <main data-testid="home" className="grain relative">
      <Nav />
      <Hero />
      <HelloSection />
      <ServiceTags />
      <LogoMarquee />
      <VideosSection />
      <ProcessSection />
      <ContactSection />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
